// extracted by mini-css-extract-plugin
export var blue = "_40-h";
export var brand = "_40-d";
export var darkGrey = "_40-g";
export var disabled = "_40-6";
export var disabledSubtle = "_40-7";
export var error = "_40-8";
export var green = "_40-i";
export var grey = "_40-f";
export var icon = "_40-0";
export var inherit = "_40-c";
export var lightGrey = "_40-e";
export var orange = "_40-k";
export var pink = "_40-m";
export var primary = "_40-1";
export var purple = "_40-n";
export var quaternary = "_40-4";
export var quinary = "_40-5";
export var red = "_40-l";
export var secondary = "_40-2";
export var success = "_40-b";
export var tertiary = "_40-3";
export var warning = "_40-9";
export var warningSecondary = "_40-a";
export var white = "_40-o";
export var yellow = "_40-j";